// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"93675324","115":"70201b33","180":"b70310be","335":"5d1c7ec4","415":"27e9e325","704":"f62fc051","716":"dc29b213","772":"8da2484f"}[chunkId] + ".chunk.js";
};